/**
 * Loading indicator displayed at the top of the chat list while older messages are being fetched.
 * Shows three staggered pulsing dots to signal background pagination activity.
 */

import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ChatLoadMoreIndicatorProps {
  isVisible: boolean
  className?: string
}

const ChatLoadMoreIndicatorBase: React.FC<ChatLoadMoreIndicatorProps> = ({
  isVisible,
  className,
}): ReactNode => {
  if (!isVisible) return null

  return (
    <output
      className={cn(
        'chat-load-more-indicator flex items-center justify-center py-3 text-muted-foreground',
        className
      )}
      aria-label="Loading older messages"
    >
      <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current" />
      <span className="mx-0.5 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current delay-75" />
      <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current delay-150" />
    </output>
  )
}

export const ChatLoadMoreIndicator = memo(ChatLoadMoreIndicatorBase)

ChatLoadMoreIndicator.displayName = 'ChatLoadMoreIndicator'
